/* eslint-disable no-console */
import { useEffect, useState } from 'react';

export const hasResizeObserver = () => 'ResizeObserver' in window;

export const useSupportsResizeObserver = ({ defaultValue = false } = {}) => {
	const [supports, setSupports] = useState(defaultValue);

	useEffect(() => {
		setSupports(hasResizeObserver());
	}, []);

	return supports;
};

const useResizeObserver = ({ onResize, target }) => {
	const isTargetSet = !!target.current;

	useEffect(() => {
		const supports = hasResizeObserver();

		if (!supports) {
			return undefined;
		}

		const targetRef = target?.current;

		const observer = new ResizeObserver(onResize);

		if (!targetRef) {
			console.warn('No target specified for Resize Observer.');

			return undefined;
		}

		observer.observe(targetRef);

		return () => {
			observer?.disconnect(targetRef);
		};
	}, [onResize, target, isTargetSet]);
};

export default useResizeObserver;
